import { ModuleContext } from "@/stores/moduleConst";
import apiPlatformConfig from "@/apis/config/apiPlatformConfig";
import store from "@/stores/store";
import Vue from "vue";
import processAPIUrl from "@/apis/config/apiConfig";

export default class AvatarService {

  constructor() {
  }
  /**
   * Hàm lấy avatar theo UserID
   * @param {H} userID
   * @param {*} isScale
   * @param {*} height
   * @param {*} width
   * createdby nvcuong1  22/12/2020
   * modified: sửa luồng api theo luồng mới
   */
  static getAvatar(MISAID, height = 64, width = 64) {
    if (!window.config?.misaid) {
      return '#';
    }
    return `${window.config.misaid}/image/getavatar?userId=${MISAID}&width=${width}&height=${height}`;
  }
}
